import React, { useState } from 'react'
import { Parallax } from 'react-parallax'
import './css/secondpara.css'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css'

const Certifications = () => {
  SwiperCore.use([Navigation, Pagination, Autoplay])
  const [swiper, setSwiper] = useState(null)
  const params = {
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  }
  return (
    <Parallax
      className='paralax'
      bgImage='/paraImgs/certifications.jpg'
      style={{ background: 'white' }}
      strength={400}
      
    >
        <div className="overlay"></div>
        <div id='certifications' className='title' style={{color:'red'}}>CERTIFICATIONS</div>
      <div className='swiper-container'>
        <div className='swiper-button-prev'></div>

        <Swiper {...params} onSwiper={setSwiper}>
          <SwiperSlide >
            <img className='slider-img' src='/assests/Screenshot (25).png' alt='animal' />
          </SwiperSlide>
          <SwiperSlide>
            <img  className='slider-img' src='/assests/Screenshot (26).png' alt='nature' />
          </SwiperSlide>
          <SwiperSlide>
            <img  className='slider-img' src='/assests/Screenshot (27).png' alt='nature' />
          </SwiperSlide>
          <SwiperSlide>
            <img  className='slider-img' src='/assests/Screenshot (28).png' alt='nature' />
          </SwiperSlide>
          <SwiperSlide>
            <img  className='slider-img' src='/assests/Screenshot (29).png' alt='nature' />
          </SwiperSlide>
         
        </Swiper>
        <div className='swiper-button-next'></div>

        <div className='swiper-pagination'></div>
      </div>
    </Parallax>
  )
}

export default Certifications
